import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

export function Leaderboard({ user, onBack, onNavigate, gameId = '/' }) {
  const [leaderboard, setLeaderboard] = useState([]);
  const [userRank, setUserRank] = useState(null);
  const [period, setPeriod] = useState('alltime');

  const tableMap = {
    '/':             { table: 'leaderboard',             title: '🩷 Flutter Heart' },
    '/cloud':        { table: 'cloud_leaderboard',        title: '☁️ Cloud Dodge'  },
    '/flutterrush':  { table: 'heartrush_leaderboard',   title: 'Flutter Rush 🏃'  },
    '/flutterhoop':  { table: 'flutterhoop_leaderboard',   title: '🌀 Flutter Hoop'   },
    '/heartcatcher': { table: 'heartcatcher_leaderboard', title: '💝 Heart Catcher' },
    '/fluttercatch': { table: 'fluttercatch_leaderboard', title: '🫧 Flutter Catch'  },
  };

  const { table, title } = tableMap[gameId] || tableMap['/'];

  useEffect(() => {
    let query = supabase
      .from(table)
      .select('*')
      .order('score', { ascending: false })
      .limit(10);

    if (period === 'weekly') {
      const since = new Date();
      since.setDate(since.getDate() - 7);
      query = query.gte('created_at', since.toISOString());
    } else if (period === 'monthly') {
      const since = new Date();
      since.setMonth(since.getMonth() - 1);
      query = query.gte('created_at', since.toISOString());
    }

    query.then(({ data, error }) => {
      if (error) { console.error('Error fetching leaderboard:', error); return; }
      setLeaderboard(data);
      const userScores = data.filter((e) => e.user_id === user.id);
      if (userScores.length > 0) {
        const userBest = Math.max(...userScores.map((e) => e.score));
        const rank = data.findIndex((e) => e.score === userBest) + 1;
        setUserRank(rank);
      } else {
        setUserRank(null);
      }
    });
  }, [user, table, period]);

  return (
    <div className="leaderboard-container">
      <h1>{title} Leaderboard</h1>
      <div className="leaderboard-tabs">
        <button
          className={`tab-btn${period === 'weekly' ? ' active' : ''}`}
          onClick={() => setPeriod('weekly')}
        >Weekly</button>
        <button
          className={`tab-btn${period === 'monthly' ? ' active' : ''}`}
          onClick={() => setPeriod('monthly')}
        >Monthly</button>
        <button
          className={`tab-btn${period === 'alltime' ? ' active' : ''}`}
          onClick={() => setPeriod('alltime')}
        >All Time</button>
      </div>
      {userRank && <div className="user-rank">Your rank: #{userRank}</div>}
      <table className="leaderboard-table">
        <thead>
          <tr><th>Rank</th><th>Player</th><th>Score</th></tr>
        </thead>
        <tbody>
          {leaderboard.length === 0 ? (
            <tr><td colSpan={3} className="leaderboard-empty">No scores yet</td></tr>
          ) : leaderboard.map((entry, index) => (
            <tr key={entry.id} className={entry.user_id === user.id ? 'user-row' : ''}>
              <td>#{index + 1}</td>
              <td>{entry.username || entry.email}</td>
              <td>{entry.score}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <button onClick={onBack} className="btn btn-play">Play Again</button>
      {onNavigate && (
        <button onClick={() => onNavigate('leagues')} className="btn">🏅 Leagues</button>
      )}
      <button onClick={() => supabase.auth.signOut()} className="btn btn-logout">Logout</button>
    </div>
  );
}
